(function () {
  'use strict';
  if (window.EBStore2CheckoutReady) return;
  var config = window.EBCheckoutCatalog;
  if (!config || config.version !== 1 || config.origin !== 'https://ampbtf-rn.myshopify.com' || config.currency !== 'EUR') return;
  var busy = false;
  var safetyTimer;
  var retryMessage = 'Impossible de préparer le paiement. Veuillez réessayer dans un instant.';

  function showError(message) {
    document.querySelectorAll('[data-eb-checkout-error]').forEach(function (el) {
      el.textContent = message;
      el.hidden = false;
    });
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function reset() {
    busy = false;
    clearTimeout(safetyTimer);
    document.querySelectorAll('[data-eb-payment-wait]').forEach(function (el) {
      el.disabled = el.dataset.ebPaymentWasDisabled === 'true';
      el.removeAttribute('aria-busy');
      delete el.dataset.ebPaymentWait;
      delete el.dataset.ebPaymentWasDisabled;
    });
  }

  function markBusy() {
    busy = true;
    document.querySelectorAll('[data-eb-cart-form] button, [data-eb-cart-form] input').forEach(function (el) {
      el.dataset.ebPaymentWasDisabled = el.disabled ? 'true' : 'false';
      el.dataset.ebPaymentWait = 'true';
      el.disabled = true;
      el.setAttribute('aria-busy', 'true');
    });
  }

  function base64Url(value) {
    var bytes = new TextEncoder().encode(JSON.stringify(value));
    var binary = '';
    bytes.forEach(function (byte) { binary += String.fromCharCode(byte); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function buildDestination(cart) {
    if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count)) throw new Error(retryMessage);
    if (!cart.items.length || cart.item_count < 1) throw new Error('Votre panier est vide. Choisissez vos places avant de continuer.');
    if (cart.currency !== config.currency) throw new Error('La devise du panier a changé. Actualisez la page avant de réessayer.');
    var quantities = new Map();
    var rows = [];
    var totalQuantity = 0;
    var totalPrice = 0;
    cart.items.forEach(function (item) {
      if (!item || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('La quantité du panier doit être actualisée avant le paiement.');
      var product = Object.prototype.hasOwnProperty.call(config.products, item.handle) && config.products[item.handle];
      var variant = product && Object.prototype.hasOwnProperty.call(product.variants, item.variant_title) && product.variants[item.variant_title];
      // Reimports can clear the SKU; exact handle + category remain authoritative.
      var sku = typeof item.sku === 'string' ? item.sku.trim() : item.sku;
      if (!variant || (sku != null && sku !== '' && sku !== variant.sku)) throw new Error('Cette réservation ne peut pas être transférée au paiement. Veuillez contacter le service client.');
      if (!variant.available) throw new Error('Cette catégorie est complète. Veuillez choisir une autre place.');
      var expected = variant.price;
      var linePrice = expected * item.quantity;
      if (!Number.isSafeInteger(linePrice) || item.price !== expected || item.final_price !== expected || item.final_line_price !== linePrice) {
        throw new Error('Le prix du panier doit être actualisé avant le paiement. Rechargez la page ; si le problème persiste, contactez le service client.');
      }
      var target = config.tiers[expected];
      if (!target || !/^\d+$/.test(target)) throw new Error(retryMessage);
      quantities.set(target, (quantities.get(target) || 0) + item.quantity);
      totalQuantity += item.quantity;
      totalPrice += linePrice;
      // Public properties retain the actual ticket identity, never a hidden alias.
      var properties = {
        'Billet': product.title,
        'Artiste': product.artist,
        'Date': product.date,
        'Lieu': product.venue,
        'Catégorie': item.variant_title,
        'Référence': variant.sku,
        'Boutique': 'Event Billetterie'
      };
      if (item.properties && typeof item.properties.Placement === 'string') properties.Placement = item.properties.Placement;
      rows.push({quantity:item.quantity, price:expected, properties:properties});
    });
    if (!Number.isSafeInteger(totalQuantity) || totalQuantity !== cart.item_count || !Number.isSafeInteger(totalPrice) || cart.total_price !== totalPrice) {
      throw new Error('Le total du panier doit être actualisé avant le paiement. Rechargez la page avant de réessayer.');
    }
    var path = Array.from(quantities, function (entry) { return entry[0] + ':' + entry[1]; }).join(',');
    var url = new URL(config.origin + '/cart/' + path);
    var properties = rows[0].properties;
    if (rows.length > 1) {
      // Permalinks attach properties to the first target line only: show the
      // COMPLETE reservation there and retain it in the order note as well.
      // Equal-price tickets share a target variant; sum their quantities.
      var details = rows.map(function (row) {
        var p = row.properties;
        return row.quantity + ' × ' + p.Billet + ' | ' + p.Artiste + ' | ' + p.Date + ' | ' + p.Lieu + ' | ' + p['Catégorie'] + ' | ' + (row.price / 100).toFixed(2) + ' EUR/place | Réf. ' + p['Référence'] + (p.Placement ? ' | ' + p.Placement : '');
      }).join('\n');
      properties = {'Boutique':'Event Billetterie', 'Quantité totale':String(totalQuantity), 'Détail de toute la réservation':details};
      url.searchParams.set('note', 'Event Billetterie — ' + totalQuantity + ' places\n' + details);
    }
    url.searchParams.set('properties', base64Url(properties));
    return url.href;
  }

  function pendingUpdates() {
    var updates = Object.create(null);
    document.querySelectorAll('[data-eb-cart-key]').forEach(function (input) {
      var value = input.value.trim();
      var quantity = Number(value);
      if (!value || !Number.isSafeInteger(quantity) || quantity < 0) throw new Error('Indiquez un nombre entier de places, supérieur ou égal à zéro.');
      if (quantity !== Number(input.defaultValue)) updates[input.dataset.ebCartKey] = quantity;
    });
    return updates;
  }

  async function transfer(updates) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 8000);
    try {
      var changed = Object.keys(updates).length > 0;
      var options = {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal};
      if (changed) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify({updates:updates});
      }
      var response = await fetch(root() + (changed ? 'cart/update.js' : 'cart.js'), options);
      if (!response.ok) throw new Error(retryMessage);
      var cart = await response.json();
      // Do not redirect if Shopify silently caps a requested quantity.
      Object.keys(updates).forEach(function (key) {
        var line = Array.isArray(cart.items) && cart.items.find(function (item) { return item.key === key; });
        if ((line ? line.quantity : 0) !== updates[key]) throw new Error('La quantité disponible a changé. Actualisez votre panier avant de continuer.');
      });
      var destination = buildDestination(cart);
      window.location.assign(destination);
      safetyTimer = setTimeout(function () { reset(); showError(retryMessage); }, 12000);
    } finally {
      clearTimeout(timer);
    }
  }

  async function checkout() {
    if (busy) return;
    document.querySelectorAll('[data-eb-checkout-error]').forEach(function (el) { el.hidden = true; });
    try {
      var updates = pendingUpdates();
      markBusy();
      if (navigator.locks && typeof navigator.locks.request === 'function') {
        await navigator.locks.request('eb-ticket-cart', {ifAvailable:true}, async function (lock) {
          if (!lock) throw new Error('Votre panier est en cours de modification dans un autre onglet. Veuillez réessayer.');
          await transfer(updates);
        });
      } else {
        await transfer(updates);
      }
    } catch (error) {
      reset();
      showError(error && error.name === 'Error' && error.message ? error.message : retryMessage);
    }
  }

  window.addEventListener('click', function (event) {
    var element = event.target instanceof Element && event.target.closest('[data-eb-checkout], a[href]');
    if (!element) return;
    var isCheckout = element.hasAttribute('data-eb-checkout');
    if (!isCheckout && element.tagName === 'A') {
      var url = new URL(element.href, window.location.href);
      isCheckout = url.origin === window.location.origin && /\/(checkouts?)(\/|$)/.test(url.pathname);
    }
    if (!isCheckout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!element.disabled) checkout();
  }, true);

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[data-eb-checkout]')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);

  function enableCheckout() {
    if (!busy) document.querySelectorAll('[data-eb-checkout]').forEach(function (button) { button.disabled = false; });
  }
  window.addEventListener('pageshow', function (event) { if (event.persisted) reset(); });
  document.addEventListener('shopify:section:load', enableCheckout);
  window.EBStore2CheckoutReady = true;
  enableCheckout();
})();
